<template>
  <div
    v-show="isOpen"
    class="modal-attention-email swal2-container swal2-center swal-conection swal2-backdrop-show"
  >
    <div
      class="swal2-popup swal2-modal swal2-show"
      style="display: flex"
    >
      <div class="swal2-header position-relative">
        <div class="swal2-title">{{ $t('IntegrationPage.attention') }}</div>
        <button
          type="button"
          class="swal2-close d-flex"
          aria-label="Close this dialog"
          @click="UPDATE_MODAL_ATTENTION_EMAIL(false)"
        >
          ×
        </button>
      </div>
      <div class="swal2-content">
        <div class="subtitle">
          {{ $t('ProfilesPage.ModalAttentionText') }}
        </div>
        <div class="people-list">
          <div
            v-if="
              !!isToValidate &&
              peopleList.usersWithoutEmail.find((e) => e.email === '' || e.email === null)
            "
            class="error-message"
          >
            {{ $t('ProfilesPage.ModalAttentionError') }}
          </div>
          <div
            :class="[
              'people-block',
              !!isToValidate && combinedUsers.find((e) => e.email === '' || e.email === null)
                ? 'is-invalid'
                : ''
            ]"
          >
            <div
              v-for="person in combinedUsers"
              :key="person.guid"
              class="person-row"
            >
              <div class="person-info">
                <div class="picture">
                  <img
                    v-if="person.photo"
                    :src="person.photo"
                    alt="User photo"
                  />
                  <AvatarPlaceholder
                    v-else
                    size="40px"
                    :text="picturePlaceholder(person.firstName, person.lastName)"
                  />
                </div>
                <div class="text-block">
                  <div class="people-name">{{ person.firstName }} {{ person.lastName }}</div>
                  <div class="people-code">{{ person.code }}</div>
                </div>
              </div>
              <div class="person-email">
                <b-form-input
                  :id="person.guid"
                  :value="person.email"
                  lazy-formatter
                  :formatter="(e) => handleFormatter(e)"
                  @input="(e) => (person.email = e)"
                  :state="verifyState(person)"
                  :placeholder="$t('SupportPage.Email')"
                  :disabled="isUserWithEmail(person)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swal2-actions">
        <button
          type="button"
          class="swal2-cancel btn btn-outline-danger ml-1 d-inline-block"
          @click="UPDATE_MODAL_ATTENTION_EMAIL(false)"
        >
          {{ $t('IntegrationPage.cancel') }}
        </button>
        <button
          type="button"
          class="swal2-confirm btn btn-primary d-inline-block"
          @click="onSave()"
        >
          {{ $t('IntegrationPage.Save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { avatarText } from '@core/utils/filter';
  import { BFormGroup, BFormInput, BCol } from 'bootstrap-vue';
  import { mapState, mapMutations } from 'vuex';
  import AvatarPlaceholder from '@/@core/components/avatar-placeholder/index.vue';

  export default {
    components: {
      BCol,
      BFormGroup,
      BFormInput,
      AvatarPlaceholder
    },
    props: {
      device: {
        type: String,
        default: 'desktop'
      },
      isFromModalPeople: {
        type: Boolean,
        default: false
      },
      peopleList: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isOpen: false,
        isToValidate: false
      };
    },
    mounted() {
      this.UPDATE_MODAL_ATTENTION_EMAIL(false);
    },
    methods: {
      ...mapMutations('profile', ['UPDATE_MODAL_ATTENTION_EMAIL']),
      handleFormatter(e) {
        return e ? e.trim() : null;
      },
      verifyState(person) {
        if (this.peopleList.usersWithoutEmail.some((p) => p.guid === person.guid)) {
          if (!person.email) {
            return this.isToValidate ? false : null;
          }

          const currentEmail = person.email.trim();

          const isUniqueEmail =
            this.combinedUsers.filter((e) => e.email === currentEmail).length === 1;

          const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          const isValidEmailFormat = regexEmail.test(currentEmail);

          if (this.isToValidate) {
            return isUniqueEmail && isValidEmailFormat ? null : false;
          }

          return null;
        }
        return null;
      },
      fieldsValidate() {
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const hasEmptyFields = this.peopleList.usersWithoutEmail.some(
          (person) => !person.email || person.email.trim() === ''
        );

        const hasInvalidEmails = this.peopleList.usersWithoutEmail.some((person) => {
          const currentEmail = person.email?.trim();
          return currentEmail && !regexEmail.test(currentEmail);
        });

        const hasDuplicateEmails = this.peopleList.usersWithoutEmail.some((person, index) => {
          const currentEmail = person.email?.trim();
          if (!currentEmail) return false;

          const isDuplicate =
            this.peopleList.usersWithoutEmail.findIndex(
              (p) => p.email?.trim() === currentEmail && p.guid !== person.guid
            ) !== -1;

          return isDuplicate;
        });

        return !hasEmptyFields && !hasInvalidEmails && !hasDuplicateEmails;
      },
      picturePlaceholder(first_name, last_name) {
        return avatarText(first_name, last_name);
      },
      isUserWithEmail(user) {
        return this.peopleList.usersWithEmail.some((u) => u.guid === user.guid);
      },
      onSave() {
        this.isToValidate = true;
        const isValid = this.fieldsValidate();
        if (!isValid) return;
        this.$emit('confirm', this.peopleList.usersWithoutEmail, this.isFromModalPeople);
      }
    },
    computed: {
      ...mapState('profile', {
        isModalAttentionEmail: 'isModalAttentionEmail'
      }),
      combinedUsers() {
        if (Object.keys(this.peopleList).length > 0) {
          const combined = [
            ...this.peopleList.usersWithoutEmail,
            ...this.peopleList.usersWithEmail
          ];

          return combined.sort((a, b) => {
            const isInUsersWithoutEmailA = this.peopleList.usersWithoutEmail.some(
              (user) => user.guid === a.guid
            );
            const isInUsersWithoutEmailB = this.peopleList.usersWithoutEmail.some(
              (user) => user.guid === b.guid
            );

            if (isInUsersWithoutEmailA && !isInUsersWithoutEmailB) return -1;
            if (!isInUsersWithoutEmailA && isInUsersWithoutEmailB) return 1;

            const nameA = (a.firstName + ' ' + a.lastName).toLowerCase();
            const nameB = (b.firstName + ' ' + b.lastName).toLowerCase();
            return nameA.localeCompare(nameB);
          });
        }
        return [];
      }
    },
    watch: {
      isModalAttentionEmail(v) {
        this.isOpen = v;
        if (!v) {
          this.isToValidate = false;
        }
      }
    }
  };
</script>
<style lang="scss">
  .swal-conection.modal-attention-email {
    .swal2-modal {
      padding: 0 !important;
      border-radius: 6px;
      max-width: 746px;
      width: 100%;

      .swal2-header {
        background-color: #eceff1;
        padding: 20px 16px;
        border-radius: 6px 6px 0px 0px;
        flex-direction: row;
        justify-content: left;

        .swal2-title {
          color: #4c4541;
          font-weight: 600;
          font-size: 18px;
          line-height: 26px;
          margin: 0;
        }

        .swal2-close {
          border-radius: 6px;
          width: 34px;
          background-color: #ffff;
          height: 34px;
          top: -5px;
          position: absolute;
          right: -5px;
          padding-bottom: 5px;
          padding-left: 2px;

          &:hover {
            color: #4c4541;
          }
        }
      }

      .swal2-content {
        padding: 20px 16px 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .subtitle {
          text-align: left;
          color: #998f8a;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          padding-bottom: 20px;
        }

        .people-list {
          .error-message {
            padding: 15px;
            display: flex;
            align-items: center;
            border-radius: 6px;
            border: 1px solid #b71c1c;
            background: #ffebee;
            margin-bottom: 20px;
            color: #b71c1c;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
          }

          .people-block {
            max-height: 248px;
            height: 100%;
            overflow-y: auto;

            &.is-invalid {
              max-height: 176px;
            }
            .person-row {
              display: flex;
              gap: 8px;
              align-items: center;
              justify-content: space-between;
              padding-block: 7.5px;
              border-bottom: 1px solid #eee;

              .person-info {
                display: flex;
                width: 100%;
                gap: 8px;
                overflow: hidden;

                .picture img {
                  width: 40px;
                  border-radius: 50%;
                }

                .text-block {
                  min-width: 0;
                  .people-name {
                    color: #4c4541;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100%;
                  }
                  .people-code {
                    color: #998f8a;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    text-align: left;
                  }
                }
              }

              .person-email {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                padding-right: 16px;
                input {
                  max-width: 292px;
                  width: 100%;
                }
              }
            }

            &::-webkit-scrollbar {
              width: 7px;
            }

            &::-webkit-scrollbar-track {
              background: #fbeee8;
            }

            &::-webkit-scrollbar-thumb {
              background-color: #cfc4be;
              border-radius: 9px;
            }
          }
        }

        label {
          text-align: start;
        }

        .form-control.is-invalid,
        .form-control.is-valid {
          background-image: none !important;
        }
        .form-control {
          &::placeholder {
            color: #cfc4be;
          }
          &:focus {
            border-color: #974900;
          }
        }
        .invalid-feedback {
          text-align: start !important;
        }

        p {
          text-align: start;
          margin-bottom: 16px;
        }

        .swal2-html-container {
          font-weight: 400;
          text-align: left;
          font-size: 14px;
          line-height: 20px;
          color: #4c4541;
          display: flex !important;
        }
      }

      .swal2-actions {
        padding: 20px 16px;
        margin-top: 0;
        display: flex;
        justify-content: right;

        .swal2-confirm {
          margin-left: 10px !important;
          order: 2;
          padding-block: 12px;
          font-weight: 600;
          font-size: 17px;
          line-height: 20px;
          color: #ffff;
          border-color: #974900 !important;
          background-color: #974900 !important;
          border-radius: 5px;

          &:hover {
            box-shadow: none !important;
          }

          &:disabled {
            color: #7e7570 !important;
            font-size: 17px;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: 0.213px;
            background: #ece0db !important;
            border-color: #ece0db !important;
          }
        }

        .swal2-cancel {
          order: 1;
          padding-block: 12px;
          font-weight: 600;
          font-size: 17px;
          line-height: 20px;
          color: #974900 !important;
          border-radius: 5px;
          border-color: transparent !important;

          &:hover {
            background-color: #ffede1 !important;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .swal-conection.modal-attention-email {
      &.swal2-container {
        padding: 30px;
      }
      .swal2-modal {
        max-width: 710px;
      }
    }
  }

  @media (max-width: 480px) {
    .swal-conection.modal-attention-email {
      &.swal2-container {
        padding: 16px;
      }
      .swal2-modal {
        .swal2-content {
          .subtitle {
            font-size: 12px;
            line-height: 16px;
          }
          .people-list {
            .error-message {
              font-size: 12px;
              line-height: 16px;
            }
            .people-block {
              max-height: 232px;
              &.is-invalid {
                max-height: 148px;
              }
              .person-row {
                flex-direction: column;
                .person-info,
                .person-email {
                  padding-inline: 16px;

                  input {
                    max-width: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
